import type { SettingsGroup } from '../types';

/**
 * Configuración de grupos y elementos de navegación del panel de Settings.
 *
 * @remarks
 * - 'theme' y 'language' ya no son nav items independientes.
 *   Están consolidados dentro de la sección 'profile'.
 * - Al agregar un ítem nuevo, añadir el id a `SettingsSectionId` en ui.store.ts.
 */
export const settingsNavGroups: SettingsGroup[] = [
  {
    id: 'preferences',
    labelKey: 'nav.preferences',
    items: [
      { id: 'profile', groupId: 'preferences', labelKey: 'nav.profile' },
      { id: 'integrations', groupId: 'preferences', labelKey: 'nav.integrations' },
    ],
  },
  {
    id: 'organization',
    labelKey: 'nav.organization',
    items: [
      { id: 'org-info', groupId: 'organization', labelKey: 'nav.orgInfo' },
      {
        id: 'org-work-schedule',
        groupId: 'organization',
        labelKey: 'nav.orgWorkSchedule',
        adminOnly: true,
      },
    ],
  },
  {
    id: 'project',
    labelKey: 'nav.project',
    items: [{ id: 'project-config', groupId: 'project', labelKey: 'nav.projectConfig' }],
  },
];
